/**
 * Fix the topic search links, as they have escaped the
 * backticks, where they should be removed.
 *
 * @param {object} options
 *
 * @returns {void}
 */
const AmendSearchTopicLinks = (options) => {
    const links = Array.from(document.querySelectorAll(options.selectors.link));

    /**
     * Loop through the individual classes and strip the %60
     * out.
     */
    const __amendLinks = () => {
        links.forEach((link) => {
            // eslint-disable-next-line no-undef
            if (link instanceof HTMLElement) {
                const href = link.getAttribute('href');
                link.setAttribute('href', href.replace(/%60/g, ''));
            }
        });
    };

    /**
     * Ensure the link classes exist prior to ammending them.
     */
    const init = () => {
        if (links.length > 0) {
            __amendLinks();
        }
    };

    init();
};

AmendSearchTopicLinks({
    selectors: {
        link: '.funnelback-search-contextual-navigation-section__link',
    },
});
